import authorizationApi from "@/api/authorizationApi";
import restfulApi from "@/api/restfulApi";

export default {
  namespaced: true,
  state: {
    email: undefined,
    first_name: undefined,
    last_name: undefined,
    patronymic: undefined
  },
  mutations: {
    setUserInfo(state, payload) {
      Object.keys(state).forEach(i => {
        state[i] = payload[i]
      })
    }
  },
  getters: {
    getUsername(state) {
      if (!state.first_name && !state.last_name){
        return false
      }
      return `${state.first_name} ${state.last_name}`
    }
  },
  actions: {
    login({commit}, payload) {
      return authorizationApi.login(payload)
        .then(token => {
          commit('JWT/setToken', token, {root: true})
          return authorizationApi.checkAuth().then(response => {
            commit('report/setGeneralReportLinks', response.links, {root: true})
            commit('user/setUserInfo', response.user, {root: true})
            commit('setAuthorized', true, {root: true})
            restfulApi.configureRestfulData(response)
            return token
          })
        })
        .catch(reason => Promise.reject(reason))
    },

    logout({commit}) {
      commit('JWT/clearToken', {}, {root: true})
      commit('setAuthorized', false, {root: true})
    }
  }
}
